<script>

//import simplebar from "simplebar-vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
//import DateRangePicker from 'vue2-daterange-picker'
export default {
  components: {
   //simplebar,
   DatePicker,
   //DateRangePicker
  },
  data() {
    return {
      loader: false,
      employee: {},
      preDefinedRange: {},
      dateRange: {
      },
      attData: [
      ],
      monthAttDashboardData: {
        presentDays: 0,
        absentDays: 0,
        lateDays: 0,
      },
      monthDays: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      attMonth: "",
      selectedMonth: "",
      selectedYear: "",
    };
  },
  props: ['dataProp'],
  methods: {
    checkLeapYear(year) {
      let leap = false;

      if (year % 4 == 0) {
        if (year % 100 == 0) {
          if (year % 400 == 0) {
            leap = true;
          } else {
            leap = false;
          }
        } else {
          leap = true;
        }
      } else {
        leap = false;
      }
      return leap;
    },
    onDateChange() {
      var date = new Date(this.attMonth),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      var fullDate = [date.getFullYear(), mnth, day].join("-");
      this.selectedYear = fullDate.substring(0, 4);
      this.selectedMonth = fullDate.substring(5, 7);
      this.getAttendances();
    },
    async getAttendanceData() {
      var date = new Date(this.dateRange.startDate),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      let startDate = [date.getFullYear(), mnth, day].join("-");

      date = new Date(this.dateRange.endDate),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      let endDate = [date.getFullYear(), mnth, day].join("-");

      this.loader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_attendance", {
          params: { companyId: this.employee.companyId , empId: this.employee.empId, startDate: startDate, endDate: endDate},
        });
        if(response.data.success == "true") {
          this.attData = response.data.data.data;
          this.monthAttDashboardData.presentDays = response.data.data.presentDays;
          this.monthAttDashboardData.absentDays = response.data.data.absentDays;
          this.monthAttDashboardData.lateDays = response.data.data.lateDays;
        }

      } catch (error) {
       // console.log(error);
      }
      this.loader = false;
    },
    async getAttendances() {
      this.loader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_attendance", {
          params: { companyId: this.employee.companyId , empId: this.employee.empId, year: this.selectedYear, month: this.selectedMonth},
        });
        if(response.data.success == "true") {
          this.attData = response.data.data.data;
          this.monthAttDashboardData.presentDays = response.data.data.presentDays;
          this.monthAttDashboardData.absentDays = response.data.data.absentDays;
          this.monthAttDashboardData.lateDays = response.data.data.lateDays;
        }

      } catch (error) {
       // console.log(error);
      }
      this.loader = false;
    },
    exportDayWiseCSV() {
      var fields = ["date", "clockIn", "clockInTagValue", "clockOut", "clockOutTagValue", "remarks"];
      let fileName = this.employee.name + "-Day-Wise.csv";
      this.convertToCSV(this.attData, fields, fileName);
    },
    toSnakeCase(inputString) {
      return inputString.split('').map((character) => {
          if (character == character.toUpperCase()) {
              return ' ' + character;
          } else {
              return character;
          }
      })
      .join('');
    },
    async convertToCSV(data, fields, fileName) {
      const json = data;
      //var fields = Object.keys(json[0])
      //var fields = ["name", "email", "designation", "teamName", "activeHours", "idleHours", "productivity"];
      var replacer = function(key, value) { return value === null ? '' : value } 
      var csv = json.map(function(row){
        return fields.map(function(fieldName){
          return JSON.stringify(row[fieldName], replacer)
        }).join(',')
      })

      // Name, Email, Designation, Team Name, Active Hours, Idle Hours, Productivity
      /*for(var i = 0;i < fields.length;i++) {
        fields[i] = this.toSnakeCase(fields[i]);
        fields[i] = fields[i].charAt(0).toUpperCase() + fields[i].slice(1);
      }*/
      var temFields = ["Date", "Clock In", "Clock In Remarks", "Clock Out", "Clock Out Remarks", "Remarks"];
      csv.unshift(temFields.join(',')) // add header column
      csv = csv.join('\r\n');

      var exportedFilenmae = fileName;
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", exportedFilenmae);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
    },
  },
  created() {
    let today = new Date();
    today.setHours(0, 0, 0, 0)

    let yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)
    yesterday.setHours(0, 0, 0, 0);

    // Sun - 0, Mon - 1
    let dayVal = today.getDay();

    let thisWeekFirstDate = new Date();
    thisWeekFirstDate.setDate(today.getDate() - dayVal);
    thisWeekFirstDate.setHours(0, 0, 0, 0);

    let thisWeekLastDate = new Date();
    thisWeekLastDate.setDate(today.getDate() + 6 - dayVal);
    thisWeekLastDate.setHours(0, 0, 0, 0);

    let lastWeekFirstDate = new Date();
    lastWeekFirstDate.setDate(today.getDate() - dayVal - 7);
    lastWeekFirstDate.setHours(0, 0, 0, 0);

    let lastWeekLastDate = new Date();
    lastWeekLastDate.setDate(today.getDate() - dayVal - 1);
    lastWeekLastDate.setHours(0, 0, 0, 0);

    let dateVal = today.getDay();

    // Jan - 0, Dec - 11
    let monthDay = this.monthDays[today.getMonth()];
    if(today.getMonth() == 1 && this.checkLeapYear(today.getFullYear())) {
      monthDay = 29;
    }

    let lastMonthDay = 0;
    if(today.getMonth() == 0) {
      lastMonthDay = this.monthDays[11];
    } else {
      lastMonthDay = this.monthDays[today.getMonth() - 1];
      if(today.getMonth()== 2 && this.checkLeapYear(today.getFullYear())) {
        lastMonthDay = 29;
      }
    }

    let thisMonthFirstDate = new Date();
    thisMonthFirstDate.setDate(today.getDate() - dateVal);
    thisMonthFirstDate.setHours(0, 0, 0, 0);

    let thisMonthLastDate = new Date();
    thisMonthLastDate.setDate(monthDay);
    thisMonthLastDate.setHours(0, 0, 0, 0);

    let lastMonthFirstDate = new Date();
    lastMonthFirstDate.setDate(today.getDate() - dateVal - lastMonthDay);
    lastMonthFirstDate.setHours(0, 0, 0, 0);

    let lastMonthLastDate = new Date();
    lastMonthLastDate.setDate(today.getDate() - dateVal - 1);
    lastMonthLastDate.setHours(0, 0, 0, 0);

    
    this.preDefinedRange = {
        'Today': [today, today],
        'Yesterday': [yesterday, yesterday],
        'This week': [thisWeekFirstDate, thisWeekLastDate],
        'Last Week': [lastWeekFirstDate, lastWeekLastDate],
        'This month': [thisMonthFirstDate, thisMonthLastDate],
        'Last month': [lastMonthFirstDate, lastMonthLastDate],
        'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
    }  
    this.employee = this.dataProp;
    this.attMonth = new Date();
    var date = new Date(),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    var fullDate = [date.getFullYear(), mnth, day].join("-");
    this.selectedYear = fullDate.substring(0, 4);
    this.selectedMonth = fullDate.substring(5, 7);
    this.getAttendances();
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body" style="height: calc(100vh - 263px);">
      <div class="d-flex">
        <div class="col-md-6 me-2 mb-3">
          <h4 class="card-title mb-4">{{ $t('menuitems.attendance.attendanceDetails') }}</h4>
          <!--<div class="row">
            <div class="col-md-8">
                <date-range-picker
                ref="picker"
                  :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                  :showDropdowns="true"
                  :ranges="preDefinedRange"
                  v-model="dateRange"
                  :opens="'right'"
                  :placeholder="'Select Date'"
                  @update="getAttendanceData"
                  style="min-width: 188px;"
              >
              </date-range-picker>
            </div>
          </div>-->
        </div>
         <div class="col-md-2"></div>
        <div class="col-md-2">
        <date-picker
          v-model="attMonth"
          type="month"
          lang="en"
          confirm
          placeholder="Month"
          @change="onDateChange"
        ></date-picker>
        </div>
        <div class="col-md-2 text-end">
        <!--<date-picker
          v-model="attMonth"
          type="month"
          lang="en"
          confirm
          placeholder="Month"
          @change="onDateChange"
        ></date-picker>-->
        <button type="button" @click="exportDayWiseCSV" class="btn btn-outline-primary" ><i class="bx bx-download me-2"></i> {{ $t('menuitems.attendance.download') }}</button>
        </div>
      </div>
      <div class="row mb-3">
        
        <div class="col-md-6">
        <!--<date-picker
                  v-model="attMonth"
                  type="month"
                  lang="en"
                  confirm
                  placeholder="Month"
                  @change="onDateChange"
                ></date-picker>-->
         <span class="fw-bold mb-2 fs-5">{{ $t('menuitems.attendance.present') }} : {{monthAttDashboardData.presentDays}}</span> <span class="fw-bold mb-2 ms-4 fs-5">{{ $t('menuitems.attendance.absent') }} : {{monthAttDashboardData.absentDays}}</span><span class="fw-bold mb-2 ms-4 fs-5">{{ $t('menuitems.attendance.late') }} : {{monthAttDashboardData.lateDays}}</span>
        </div>
        <div class="col-md-6">
          
         
        </div>
      </div>
      <div class="is-loading">
        <div class="preloader-component" v-show="loader">
          <div class="status">
            <div class="spinner-chase">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <!--<simplebar
        v-if="attData.length > 0"
          style="max-height: 390px"
          ref="current"
        >-->
        <div class="table-responsive mt-2">
          <table class="table table-fixed">
            <thead class="">
              <tr>
                <th scope="col">{{ $t('menuitems.attendance.date') }}</th>
                <th scope="col">{{ $t('menuitems.attendance.clockIn') }}</th>
                <th scope="col">{{ $t('menuitems.attendance.clockOut') }}</th>
                <th scope="col">{{ $t('menuitems.attendance.remarks') }}</th>
              </tr>
            </thead>
            <tbody>
              

              <tr v-for="(data, index) of attData" :key="index">
                <td>
                  <p class="text-muted mb-0">{{data.date}}</p>
                </td>
                <td><span class="text-muted mb-0">{{data.clockIn}}</span><br/> <span :class="`badge font-size-8 bg-${data.clockInTag}`">{{data.clockInTagValue}}</span></td>
                <td><span class="text-muted mb-0">{{data.clockOut}}</span><br/> <span :class="`badge font-size-8 bg-${data.clockOutTag}`">{{data.clockOutTagValue}}</span></td>
                <td>
                  <span class="text-muted mb-0">{{data.remarks}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--</simplebar>-->
         <div v-if="attData.length <= 0">
          <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 14%;margin-left: 42%;" height="180" width="180"><br />
          <span style="margin-left: 43%;" class="mt-2 text-secondary fw-bold fs-3">No Data Found</span>
        </div>
      </div>
    </div>
  </div>
  <!-- end card -->
</template>

<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
tbody {
    display:block;
    height: calc(100vh - 442px);
    overflow:auto;
}
thead, tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
}
</style>